import React from 'react';
import { vars } from '../../theme';
import HBBannerBase from '../HBBanner/HBBannerBase';
import HBIndicatorAI from '../HBIndicatorAI/HBIndicatorAI';
import { HBBannerProps } from '../HBBanner/HBBanner.types';
import { MustIncludeOneOfBasicTestIdProps } from '../common/internal/test-id.types';
import {
    aiInlineFill,
    aiAccentLineGradient,
    aiInlineStroke,
    adaptiveGradientBorder
} from '../../styles/mixins';
import { buttonThemes } from '../HBButton/HBButton.styles';
import styled from 'styled-components';
import { BannerBorderRadiusValue } from './HBBanner.styles';

export interface Props
    extends Omit<
        HBBannerProps,
        'accentLine' | 'background' | 'whiteBanner' | 'actionsTheme'
    > {
    primaryActionTheme?: keyof typeof buttonThemes;
}

const gradientBorderWidth = '1px';

const AIBanner = (props: Props & MustIncludeOneOfBasicTestIdProps) => {
    const { primaryActionTheme = 'button-link-blue', ...restProps } = props;

    return (
        <StyledHBBanner
            icon={() => <HBIndicatorAI size="sm" />}
            primaryActionTheme={primaryActionTheme}
            {...restProps}
            accentLine={aiAccentLineGradient.join('')}
            background={[
                aiInlineFill.join(''),
                vars.colors.surface.container
            ].join(', ')}
            gradientBorderWidth={gradientBorderWidth}
        />
    );
};

export default AIBanner;

const StyledHBBanner = styled(HBBannerBase)`
    ${adaptiveGradientBorder(
        aiInlineStroke,
        BannerBorderRadiusValue.join(''),
        gradientBorderWidth
    )};
`;
